export const ALARM_TALK_FLAG = 'isAlimTalk';
